import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import UserWidget from "../../../UI/UserWidget";
import InfiniteScroll from "react-infinite-scroller";
import * as searchActions from "../../../../_actions/searchActions";
import getSearchResults from "../../../../_selectors/searchSelectors/getSearchResults";
import getSearchFilter from "../../../../_selectors/searchSelectors/getSearchFilter";
import getSearchLastResult from "../../../../_selectors/searchSelectors/getSearchLastResult";
import PageSubTitle from "../../../UI/PageSubTitle";

class Results extends Component {
  loadMoreItems = page => {
    const { filter, lastResult, loadMore } = this.props;
    loadMore({ lastResult, filter });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.loadMoreItems}
        hasMore={lastResult !== null}
        initialLoad={false}
        loader={
          <div
            className="loader"
            style={{
              height: "50px",
              background: "#4d4d4d",
              textAlign: "center",
              lineHeight: "50px",
              color: "#fff",
              fontSize: "1.5em",
              marginTop: "1em"
            }}
          >
            Please Wait
          </div>
        }
      >
        <div className="row">
          {results.length === 0 ? (
            <PageSubTitle center>
              <h3>No Results</h3>
            </PageSubTitle>
          ) : (
            map(results, result => (
              <div key={result.id} className="col-md-4">
                <UserWidget user={result} />
              </div>
            ))
          )}
        </div>
      </InfiniteScroll>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getSearchResults(state),
  filter: getSearchFilter(state),
  lastResult: getSearchLastResult(state)
});
const mapDispatchToProps = dispatch => ({
  loadMore: payload => dispatch(searchActions.loadMoreSearchResults(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Results);



// WEBPACK FOOTER //
// ./src/_components/Search/Normal/Results/index.js